module.exports = __webpack_public_path__ + "static/media/Logo_img01.aea8dbb6.png";